import { LoadingButton } from '@mui/lab'
import {
  Box,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { toast } from 'react-toastify'
import Iconify from 'src/components/iconify/Iconify'
import { useFetchCreateUser } from 'src/services/users'
import { useCompaniesStore } from 'src/store/useCompaniesStore'
import { useUsersStore } from 'src/store/users'
// import { useFetchGetCompanies } from ''

const CreateUserForm = () => {
  const { companies } = useCompaniesStore((state) => state)
  const [showPassword, setShowPassword] = useState(false)
  const { control, handleSubmit, watch, reset } = useForm({
    defaultValues: {
      email: '',
      username: '',
      password: '',
      confirm_password: '',
      groups: '',
      company: '',
      firstName: '',
      lastName: '',
      phoneNumber: '',
    },
  })
  const { isSuccess, mutate: createUser, data } = useFetchCreateUser()
  const { users, handleUsers } = useUsersStore((state) => state)
  const pwd = watch('password')

  const onSubmit = (data) => {
    const { email, username, password, groups, company, firstName, lastName, phoneNumber } = data
    createUser({
      email,
      username,
      password,
      groups,
      company_client: company,
      first_name: firstName,
      last_name: lastName,
      phone_number: phoneNumber,
    })
  }

  useEffect(() => {
    ;(async () => {
      try {
        if (isSuccess) {
          const { email, groups, company, firstName, lastName, phoneNumber, username } = watch()
          const companyName = companies.find((cmp) => cmp.id === company)
          const userParsed = {
            id: data.results.user_id,
            email,
            username,
            groups,
            isActive: true,
            firstName,
            lastName,
            phoneNumber,
            userInfo: { company: { name: companyName?.name ?? '', id: companyName?.id ?? '' } },
          }

          handleUsers([...users, userParsed])
          reset({ email: '', password: '', confirm_password: '', groups: '' })
          toast.success(data.results.message)
        }
      } catch (error) {
        toast.error('Failed to create user')
      }
    })()
  }, [isSuccess])

  return (
    <Box
      component="form"
      method="post"
      onSubmit={handleSubmit(onSubmit)}
      sx={{ height: '100%', overflowY: 'scroll', position: 'relative' }}
    >
      <Stack spacing={3}>
        <Typography component="h2" variant="h4" textAlign="center">
          Create user
        </Typography>
        <Controller
          name="email"
          control={control}
          rules={{
            required: 'This field is required',
            pattern: {
              value: /^[-\w.%+]{1,64}@(?:[A-Z0-9-]{1,63}\.){1,125}[A-Z]{2,63}$/i,
              message: 'Invalid email address',
            },
          }}
          render={({ field }) => <TextField {...field} label="Email address" />}
        />
        <Controller
          name="username"
          control={control}
          rules={{
            required: 'This field is required',
          }}
          render={({ field }) => <TextField {...field} label="Username" />}
        />
        <Controller
          name="firstName"
          control={control}
          rules={{
            required: 'This field is required',
          }}
          render={({ field }) => <TextField {...field} label="First Name" />}
        />
        <Controller
          name="lastName"
          control={control}
          rules={{
            required: 'This field is required',
          }}
          render={({ field }) => <TextField {...field} label="Last Name" />}
        />
        <Controller
          name="phoneNumber"
          control={control}
          render={({ field }) => <TextField {...field} label="Phone Number" type="number" />}
        />
        <Controller
          name="company"
          control={control}
          render={({ field }) => (
            <FormControl fullWidth>
              <InputLabel>Company</InputLabel>
              <Select {...field} label="group">
                {/* getCompanies */}
                {companies.map((company) => (
                  <MenuItem key={company.id} value={company.id}>
                    {company.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}
        />
        <Controller
          name="groups"
          control={control}
          rules={{ required: 'This field is required' }}
          render={({ field }) => (
            <FormControl fullWidth>
              <InputLabel>group</InputLabel>
              <Select {...field} label="group">
                <MenuItem value="admin">Admin</MenuItem>
                <MenuItem value="user">User</MenuItem>
              </Select>
            </FormControl>
          )}
        />

        <Controller
          name="password"
          control={control}
          rules={{ required: 'This field is required' }}
          render={({ field }) => (
            <TextField
              {...field}
              name="password"
              label="Password"
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                      <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )}
        />

        <Controller
          name="confirm_password"
          control={control}
          rules={{
            required: 'This field is required',
            validate: (value) => value === pwd || 'The passwords do not match',
          }}
          render={({ field }) => (
            <TextField
              {...field}
              name="confirm_password"
              label="Confirm password"
              type={showPassword ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                      <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          )}
        />
      </Stack>
      <Box sx={{ width: '100%', position: 'fixed', bottom: 0, left: 0, padding: '10px' }}>
        <LoadingButton fullWidth size="large" type="submit" variant="contained">
          create
        </LoadingButton>
      </Box>
    </Box>
  )
}

export default CreateUserForm
